import { useEffect, useState } from "react";
import "./Report.css";
import "./Comparison.css";
import axios from "axios";
import config from "../../config";
import { Form } from "react-bootstrap";

const ComparisonPage = (id1) => {
    const [expList, setexpList] = useState([]);
    const [leftExperiment, setLeftExperiment] = useState();
    const [rightExperiment, setRightExperiment] = useState();

    const ghg_emission = `${config.apiUrl}/api/report/images/ghg-emission/`;
    const co2_comparison = `${config.apiUrl}/api/report/images/co2-comparison/`;
    const pdf_full = `${config.apiUrl}/api/report/images/pdf-full/`;
    const beta_full = `${config.apiUrl}/api/report/images/beta-full/`;
    const ccs_full = `${config.apiUrl}/api/report/images/ccs-full/`;
    const cce_design1 = `${config.apiUrl}/api/report/images/cce-design1/`; 
    const cce_design2 = `${config.apiUrl}/api/report/images/cce-design2/`;
    
    useEffect(() => {
        axios.get(`${config.apiUrl}/api/experiment/`)
          .then(response => {
            setexpList(response.data);
          })
          .catch(error => {
            console.log(error.message);
          });
      }, []);

    const handleLeftChange = (e) => {
        if(e.target.value === "") return;
        axios.get(`${config.apiUrl}/api/experiment/${e.target.value}`)
            .then(response => {
                console.log(response.data);
                setLeftExperiment(response.data);
        });
    };
    const handleRightChange = (e) => {
        if(e.target.value === "") return;
        axios.get(`${config.apiUrl}/api/experiment/${e.target.value}`)
            .then(response => {
                setRightExperiment(response.data);
        });
    };

    return (
        <div className="page__container">
            <div className="page__head">
            </div>
            <div className="page__body">
                <div className="page__label">

                    <table className="comp_table">
                        <tr>
                            <td>Experiment</td>
                            <td><Form.Select
                                    size="md"
                                    style={{ width: "500px" }}
                                    onChange={handleLeftChange}>
                                    <option value="">Select Experiment 1</option>
                                    {Object.keys(expList).map(exp => (
                                        <option key={expList[exp].id} value={expList[exp].id}>{expList[exp].title} ({expList[exp].id})</option>
                                    ))}
                                </Form.Select></td>
                            <td>
                            <Form.Select
                                        size="md"
                                        style={{ width: "500px" }}
                                        onChange={handleRightChange}>
                                        <option value="">Select Experiment 2</option>
                                        {Object.keys(expList).map(exp => (
                                        <option key={expList[exp].id} value={expList[exp].id}>{expList[exp].title} ({expList[exp].id})</option>
                                    ))}
                                    </Form.Select>
                            </td>
                        </tr>
                        <tr>
                            <td className="comp_label" >ID</td>
                            <td>{leftExperiment?.id}</td>
                            <td>{rightExperiment?.id}</td>
                        </tr>

                        <tr>
                            <td className="comp_label" >Design Specification</td>
                            <td>{leftExperiment?.design_specification}</td>
                            <td>{rightExperiment?.design_specification}</td>
                        </tr>

                        <tr>
                            <td className="comp_label" >Analysis Period</td>
                            <td>{leftExperiment?.analysisPeriod}</td>
                            <td>{rightExperiment?.analysisPeriod}</td>
                        </tr>

                        <tr>
                            <td className="comp_label" >Design Life</td>
                            <td>{leftExperiment?.design_life}</td>
                            <td>{rightExperiment?.design_life}</td>
                        </tr>

                        <tr>
                            <td className="comp_label" >Number of Iterations</td>
                            <td>{leftExperiment?.number_of_iterations}</td>
                            <td>{rightExperiment?.number_of_iterations}</td>
                        </tr>

                        <tr>
                            <td className="comp_label" >Status</td>
                            <td>{leftExperiment?.status}</td>
                            <td>{rightExperiment?.status}</td>
                        </tr>

                        <tr>
                            <td colSpan={3} className="comp_section-title">REPORT</td>
                        </tr>

                        <tr>
                            <td className="comp_label">GHG Emission</td>
                            <td><img className="repd__diagram" src={ghg_emission + leftExperiment?.id} alt="" /></td>
                            <td><img className="repd__diagram" src={ghg_emission + rightExperiment?.id} alt="" /></td>
                        </tr>

                        <tr>
                            <td className="comp_label">CO2 comparison</td>
                            <td><img className="repd__diagram" src={co2_comparison + leftExperiment?.id} alt="" /></td>
                            <td><img className="repd__diagram" src={co2_comparison + rightExperiment?.id} alt="" /></td>
                        </tr>

                        <tr>
                            <td className="comp_label">pdf full</td>
                            <td><img className="repd__diagram" src={pdf_full + leftExperiment?.id} alt="" /></td>
                            <td><img className="repd__diagram" src={pdf_full + rightExperiment?.id} alt="" /></td>
                        </tr>

                        <tr>
                            <td className="comp_label">beta_full</td>
                            <td><img className="repd__diagram" src={beta_full + leftExperiment?.id} alt="" /></td>
                            <td><img className="repd__diagram" src={beta_full + rightExperiment?.id} alt="" /></td>
                        </tr>

                        <tr>
                            <td className="comp_label">ccs_full</td>
                            <td><img className="repd__diagram" src={ccs_full + leftExperiment?.id} alt="" /></td>
                            <td><img className="repd__diagram" src={ccs_full + rightExperiment?.id} alt="" /></td>
                        </tr>

                        <tr>
                            <td className="comp_label">cce_design1</td>
                            <td><img className="repd__diagram" src={cce_design1 + leftExperiment?.id} alt="" /></td>
                            <td><img className="repd__diagram" src={cce_design1 + rightExperiment?.id} alt="" /></td>
                        </tr>

                        <tr>
                            <td className="comp_label">cce_design2</td>
                            <td><img className="repd__diagram" src={cce_design2 + leftExperiment?.id} alt="" /></td>
                            <td><img className="repd__diagram" src={cce_design2 + rightExperiment?.id} alt="" /></td>
                        </tr>

                        <tr>
                            <td colSpan={3} className="comp_section-title">CONTEXT</td>
                        </tr>

                        <tr>
                            <td className="comp_label">id</td>
                            <td>{leftExperiment?.context?.id}</td>
                            <td>{rightExperiment?.context?.id}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">state</td>
                            <td>{leftExperiment?.context?.state}</td>
                            <td>{rightExperiment?.context?.state}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">annualPrecipitationDays</td>
                            <td>{leftExperiment?.context?.annualPrecipitationDays}</td>
                            <td>{rightExperiment?.context?.annualPrecipitationDays}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">functionalSystem</td>
                            <td>{leftExperiment?.context?.functionalSystem}</td>
                            <td>{rightExperiment?.context?.functionalSystem}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">laneWidth</td>
                            <td>{leftExperiment?.context?.laneWidth}</td>
                            <td>{rightExperiment?.context?.laneWidth}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">numberOfLanes</td>
                            <td>{leftExperiment?.context?.numberOfLanes}</td>
                            <td>{rightExperiment?.context?.numberOfLanes}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">pavementLength</td>
                            <td>{leftExperiment?.context?.pavementLength}</td>
                            <td>{rightExperiment?.context?.pavementLength}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">precipitationThreshold</td>
                            <td>{leftExperiment?.context?.precipitationThreshold}</td>
                            <td>{rightExperiment?.context?.precipitationThreshold}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">shoulderType</td>
                            <td>{leftExperiment?.context?.shoulderType}</td>
                            <td>{rightExperiment?.context?.shoulderType}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">shoulderWidth</td>
                            <td>{leftExperiment?.context?.shoulderWidth}</td>
                            <td>{rightExperiment?.context?.shoulderWidth}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">solarRadiation</td>
                            <td>{leftExperiment?.context?.solarRadiation}</td>
                            <td>{rightExperiment?.context?.solarRadiation}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">trafficDirection</td>
                            <td>{leftExperiment?.context?.trafficDirection}</td>
                            <td>{rightExperiment?.context?.trafficDirection}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">trafficVolume</td>
                            <td>{leftExperiment?.context?.trafficVolume}</td>
                            <td>{rightExperiment?.context?.trafficVolume}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">urbanRuralClass</td>
                            <td>{leftExperiment?.context?.urbanRuralClass}</td>
                            <td>{rightExperiment?.context?.urbanRuralClass}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">aadtAllLane (min|max|mean|dis)</td>
                            <td>{leftExperiment?.context?.aadtAllLane?.min} | {leftExperiment?.context?.aadtAllLane?.max} | {leftExperiment?.context?.aadtAllLane?.mean} | {leftExperiment?.context?.aadtAllLane?.distribution} </td>
                            <td>{rightExperiment?.context?.aadtAllLane?.min} | {rightExperiment?.context?.aadtAllLane?.max} | {rightExperiment?.context?.aadtAllLane?.mean} | {rightExperiment?.context?.aadtAllLane?.distribution} </td>
                        </tr>

                        <tr>
                            <td className="comp_label">aadtPerLane (min|max|mean|dis)</td>
                            <td>{leftExperiment?.context?.aadtPerLane?.min} | {leftExperiment?.context?.aadtPerLane?.max} | {leftExperiment?.context?.aadtPerLane?.mean} | {leftExperiment?.context?.aadtPerLane?.distribution} </td>
                            <td>{rightExperiment?.context?.aadtPerLane?.min} | {rightExperiment?.context?.aadtPerLane?.max} | {rightExperiment?.context?.aadtPerLane?.mean} | {rightExperiment?.context?.aadtPerLane?.distribution} </td>
                        </tr>

                        <tr>
                            <td className="comp_label">aadttAllLane (min|max|mean|dis)</td>
                            <td>{leftExperiment?.context?.aadttAllLane?.min} | {leftExperiment?.context?.aadttAllLane?.max} | {leftExperiment?.context?.aadttAllLane?.mean} | {leftExperiment?.context?.aadttAllLane?.distribution} </td>
                            <td>{rightExperiment?.context?.aadttAllLane?.min} | {rightExperiment?.context?.aadttAllLane?.max} | {rightExperiment?.context?.aadttAllLane?.mean} | {rightExperiment?.context?.aadttAllLane?.distribution} </td>
                        </tr>

                        <tr>
                            <td className="comp_label">aadttPerLane (min|max|mean|dis)</td>
                            <td>{leftExperiment?.context?.aadttPerLane?.min} | {leftExperiment?.context?.aadttPerLane?.max} | {leftExperiment?.context?.aadttPerLane?.mean} | {leftExperiment?.context?.aadttPerLane?.distribution} </td>
                            <td>{rightExperiment?.context?.aadttPerLane?.min} | {rightExperiment?.context?.aadttPerLane?.max} | {rightExperiment?.context?.aadttPerLane?.mean} | {rightExperiment?.context?.aadttPerLane?.distribution} </td>
                        </tr>

                        <tr>
                            <td className="comp_label">reliability (min|max|mean|dis)</td>
                            <td>{leftExperiment?.context?.reliability?.min} | {leftExperiment?.context?.reliability?.max} | {leftExperiment?.context?.reliability?.mean} | {leftExperiment?.context?.reliability?.distribution} </td>
                            <td>{rightExperiment?.context?.reliability?.min} | {rightExperiment?.context?.reliability?.max} | {rightExperiment?.context?.reliability?.mean} | {rightExperiment?.context?.reliability?.distribution} </td>
                        </tr>

                        <tr>
                            <td className="comp_label">trafficGrowth (min|max|mean|dis)</td>
                            <td>{leftExperiment?.context?.trafficGrowth?.min} | {leftExperiment?.context?.trafficGrowth?.max} | {leftExperiment?.context?.trafficGrowth?.mean} | {leftExperiment?.context?.trafficGrowth?.distribution} </td>
                            <td>{rightExperiment?.context?.trafficGrowth?.min} | {rightExperiment?.context?.trafficGrowth?.max} | {rightExperiment?.context?.trafficGrowth?.mean} | {rightExperiment?.context?.trafficGrowth?.distribution} </td>
                        </tr>

                        <tr>
                            <td className="comp_label">trafficSpeed (min|max|mean|dis)</td>
                            <td>{leftExperiment?.context?.trafficSpeed?.min} | {leftExperiment?.context?.trafficSpeed?.max} | {leftExperiment?.context?.trafficSpeed?.mean} | {leftExperiment?.context?.trafficSpeed?.distribution} </td>
                            <td>{rightExperiment?.context?.trafficSpeed?.min} | {rightExperiment?.context?.trafficSpeed?.max} | {rightExperiment?.context?.trafficSpeed?.mean} | {rightExperiment?.context?.trafficSpeed?.distribution} </td>
                        </tr>

                        <tr>
                            <td className="comp_label">truckPercentage (min|max|mean|dis)</td>
                            <td>{leftExperiment?.context?.truckPercentage?.min} | {leftExperiment?.context?.truckPercentage?.max} | {leftExperiment?.context?.truckPercentage?.mean} | {leftExperiment?.context?.truckPercentage?.distribution} </td>
                            <td>{rightExperiment?.context?.truckPercentage?.min} | {rightExperiment?.context?.truckPercentage?.max} | {rightExperiment?.context?.truckPercentage?.mean} | {rightExperiment?.context?.truckPercentage?.distribution} </td>
                        </tr>


                        <tr>
                            <td colSpan={3} className="comp_section-title">DESIGN 1</td>
                        </tr>

                        <tr>
                            <td className="comp_label">ID</td>
                            <td>{leftExperiment?.design1?.id}</td>
                            <td>{rightExperiment?.design1?.id}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Design Title</td>
                            <td>{leftExperiment?.design1?.title}</td>
                            <td>{rightExperiment?.design1?.title}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Surface (min|max)</td>
                            <td>{leftExperiment?.design1?.surface.type} ({leftExperiment?.design1?.surface.thickness.min} | {leftExperiment?.design1?.surface.thickness.max})</td>
                            <td>{rightExperiment?.design1?.surface.type} ({rightExperiment?.design1?.surface.thickness.min} | {rightExperiment?.design1?.surface.thickness.max})</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Base (min|max)</td>
                            <td>{leftExperiment?.design1?.base.type} ({leftExperiment?.design1?.base.thickness.min} | {leftExperiment?.design1?.base.thickness.max})</td>
                            <td>{rightExperiment?.design1?.base.type} ({rightExperiment?.design1?.base.thickness.min} | {rightExperiment?.design1?.base.thickness.max})</td>
                        </tr>

                        <tr>
                            <td className="comp_label">k value</td>
                            <td>{leftExperiment?.design1?.kValue.min}</td>
                            <td>{rightExperiment?.design1?.kValue.max}</td>
                        </tr>

                        {leftExperiment?.design1?.surface.type === "JPCP" && ( 
                        <>
                            <tr>
                                <td className="comp_label">PCC Elastic Modulus</td>
                                <td>{leftExperiment?.design1?.jpcpDesign?.pccElasticModulus.min} | {leftExperiment?.design1?.jpcpDesign?.pccElasticModulus.max} | {leftExperiment?.design1?.jpcpDesign?.pccElasticModulus.mean} | {leftExperiment?.design1?.jpcpDesign?.pccElasticModulus.distribution}</td>
                                <td>{rightExperiment?.design1?.jpcpDesign?.pccElasticModulus.min} | {rightExperiment?.design1?.jpcpDesign?.pccElasticModulus.max} | {rightExperiment?.design1?.jpcpDesign?.pccElasticModulus.mean} | {rightExperiment?.design1?.jpcpDesign?.pccElasticModulus.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">PCC Comp Strength</td>
                                <td>{leftExperiment?.design1?.jpcpDesign?.pccCompStrength.min} | {leftExperiment?.design1?.jpcpDesign?.pccCompStrength.max} | {leftExperiment?.design1?.jpcpDesign?.pccCompStrength.mean} | {leftExperiment?.design1?.jpcpDesign?.pccCompStrength.distribution}</td>
                                <td>{rightExperiment?.design1?.jpcpDesign?.pccCompStrength.min} | {rightExperiment?.design1?.jpcpDesign?.pccCompStrength.max} | {rightExperiment?.design1?.jpcpDesign?.pccCompStrength.mean} | {rightExperiment?.design1?.jpcpDesign?.pccCompStrength.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">PCC Modules Of Rupture</td>
                                <td>{leftExperiment?.design1?.jpcpDesign?.pccModulesOfRupture.min} | {leftExperiment?.design1?.jpcpDesign?.pccModulesOfRupture.max} | {leftExperiment?.design1?.jpcpDesign?.pccModulesOfRupture.mean} | {leftExperiment?.design1?.jpcpDesign?.pccModulesOfRupture.distribution}</td>
                                <td>{rightExperiment?.design1?.jpcpDesign?.pccModulesOfRupture.min} | {rightExperiment?.design1?.jpcpDesign?.pccModulesOfRupture.max} | {rightExperiment?.design1?.jpcpDesign?.pccModulesOfRupture.mean} | {rightExperiment?.design1?.jpcpDesign?.pccModulesOfRupture.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Coefficient Of Thermal Expansion</td>
                                <td>{leftExperiment?.design1?.jpcpDesign?.coefficientOfThermalExpansion.min} | {leftExperiment?.design1?.jpcpDesign?.coefficientOfThermalExpansion.max} | {leftExperiment?.design1?.jpcpDesign?.coefficientOfThermalExpansion.mean} | {leftExperiment?.design1?.jpcpDesign?.coefficientOfThermalExpansion.distribution}</td>
                                <td>{rightExperiment?.design1?.jpcpDesign?.coefficientOfThermalExpansion.min} | {rightExperiment?.design1?.jpcpDesign?.coefficientOfThermalExpansion.max} | {rightExperiment?.design1?.jpcpDesign?.coefficientOfThermalExpansion.mean} | {rightExperiment?.design1?.jpcpDesign?.coefficientOfThermalExpansion.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Joint Spacing</td>
                                <td>{leftExperiment?.design1?.jpcpDesign?.jointSpacing.min} | {leftExperiment?.design1?.jpcpDesign?.jointSpacing.max} | {leftExperiment?.design1?.jpcpDesign?.jointSpacing.mean} | {leftExperiment?.design1?.jpcpDesign?.jointSpacing.distribution}</td>
                                <td>{rightExperiment?.design1?.jpcpDesign?.jointSpacing.min} | {rightExperiment?.design1?.jpcpDesign?.jointSpacing.max} | {rightExperiment?.design1?.jpcpDesign?.jointSpacing.mean} | {rightExperiment?.design1?.jpcpDesign?.jointSpacing.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Base Resilient Modulus</td>
                                <td>{leftExperiment?.design1?.jpcpDesign?.baseResilientModulus.min} | {leftExperiment?.design1?.jpcpDesign?.baseResilientModulus.max} | {leftExperiment?.design1?.jpcpDesign?.baseResilientModulus.mean} | {leftExperiment?.design1?.jpcpDesign?.baseResilientModulus.distribution}</td>
                                <td>{rightExperiment?.design1?.jpcpDesign?.baseResilientModulus.min} | {rightExperiment?.design1?.jpcpDesign?.baseResilientModulus.max} | {rightExperiment?.design1?.jpcpDesign?.baseResilientModulus.mean} | {rightExperiment?.design1?.jpcpDesign?.baseResilientModulus.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Subgrade Resilient Modulus</td>
                                <td>{leftExperiment?.design1?.jpcpDesign?.subgradeResilientModulus.min} | {leftExperiment?.design1?.jpcpDesign?.subgradeResilientModulus.max} | {leftExperiment?.design1?.jpcpDesign?.subgradeResilientModulus.mean} | {leftExperiment?.design1?.jpcpDesign?.subgradeResilientModulus.distribution}</td>
                                <td>{rightExperiment?.design1?.jpcpDesign?.subgradeResilientModulus.min} | {rightExperiment?.design1?.jpcpDesign?.subgradeResilientModulus.max} | {rightExperiment?.design1?.jpcpDesign?.subgradeResilientModulus.mean} | {rightExperiment?.design1?.jpcpDesign?.subgradeResilientModulus.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Depth To Rigid Found</td>
                                <td>{leftExperiment?.design1?.jpcpDesign?.depthToRigidFound.min} | {leftExperiment?.design1?.jpcpDesign?.depthToRigidFound.max} | {leftExperiment?.design1?.jpcpDesign?.depthToRigidFound.mean} | {leftExperiment?.design1?.jpcpDesign?.depthToRigidFound.distribution}</td>
                                <td>{rightExperiment?.design1?.jpcpDesign?.depthToRigidFound.min} | {rightExperiment?.design1?.jpcpDesign?.depthToRigidFound.max} | {rightExperiment?.design1?.jpcpDesign?.depthToRigidFound.mean} | {rightExperiment?.design1?.jpcpDesign?.depthToRigidFound.distribution}</td>
                            </tr>
                        </>)}

                        {leftExperiment?.design1?.surface.type === "HMA" && ( 
                        <>
                            <tr>
                                <td className="comp_label">AC Binder Type</td>
                                <td>{leftExperiment?.design1?.hmaDesign?.acBinderType.value}</td>
                                <td>{rightExperiment?.design1?.hmaDesign?.acBinderType.value}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Effective Binder Content</td>
                                <td>{leftExperiment?.design1?.hmaDesign?.effectiveBinderContent.min} | {leftExperiment?.design1?.hmaDesign?.effectiveBinderContent.max} | {leftExperiment?.design1?.hmaDesign?.effectiveBinderContent.mean} | {leftExperiment?.design1?.hmaDesign?.effectiveBinderContent.distribution}</td>
                                <td>{rightExperiment?.design1?.hmaDesign?.effectiveBinderContent.min} | {rightExperiment?.design1?.hmaDesign?.effectiveBinderContent.max} | {rightExperiment?.design1?.hmaDesign?.effectiveBinderContent.mean} | {rightExperiment?.design1?.hmaDesign?.effectiveBinderContent.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Air Voids</td>
                                <td>{leftExperiment?.design1?.hmaDesign?.airVoids.min} | {leftExperiment?.design1?.hmaDesign?.airVoids.max} | {leftExperiment?.design1?.hmaDesign?.airVoids.mean} | {leftExperiment?.design1?.hmaDesign?.airVoids.distribution}</td>
                                <td>{rightExperiment?.design1?.hmaDesign?.airVoids.min} | {rightExperiment?.design1?.hmaDesign?.airVoids.max} | {rightExperiment?.design1?.hmaDesign?.airVoids.mean} | {rightExperiment?.design1?.hmaDesign?.airVoids.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Base Resilient Modulus</td>
                                <td>{leftExperiment?.design1?.hmaDesign?.baseResilientModulus.min} | {leftExperiment?.design1?.hmaDesign?.baseResilientModulus.max} | {leftExperiment?.design1?.hmaDesign?.baseResilientModulus.mean} | {leftExperiment?.design1?.hmaDesign?.baseResilientModulus.distribution}</td>
                                <td>{rightExperiment?.design1?.hmaDesign?.baseResilientModulus.min} | {rightExperiment?.design1?.hmaDesign?.baseResilientModulus.max} | {rightExperiment?.design1?.hmaDesign?.baseResilientModulus.mean} | {rightExperiment?.design1?.hmaDesign?.baseResilientModulus.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Subgrade Resilient Modulus</td>
                                <td>{leftExperiment?.design1?.hmaDesign?.subgradeResilientModulus.min} | {leftExperiment?.design1?.hmaDesign?.subgradeResilientModulus.max} | {leftExperiment?.design1?.hmaDesign?.subgradeResilientModulus.mean} | {leftExperiment?.design1?.hmaDesign?.subgradeResilientModulus.distribution}</td>
                                <td>{rightExperiment?.design1?.hmaDesign?.subgradeResilientModulus.min} | {rightExperiment?.design1?.hmaDesign?.subgradeResilientModulus.max} | {rightExperiment?.design1?.hmaDesign?.subgradeResilientModulus.mean} | {rightExperiment?.design1?.hmaDesign?.subgradeResilientModulus.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Depth To Rigid Foundation</td>
                                <td>{leftExperiment?.design1?.hmaDesign?.depthToRigidFoundation.min} | {leftExperiment?.design1?.hmaDesign?.depthToRigidFoundation.max} | {leftExperiment?.design1?.hmaDesign?.depthToRigidFoundation.mean} | {leftExperiment?.design1?.hmaDesign?.depthToRigidFoundation.distribution}</td>
                                <td>{rightExperiment?.design1?.hmaDesign?.depthToRigidFoundation.min} | {rightExperiment?.design1?.hmaDesign?.depthToRigidFoundation.max} | {rightExperiment?.design1?.hmaDesign?.depthToRigidFoundation.mean} | {rightExperiment?.design1?.hmaDesign?.depthToRigidFoundation.distribution}</td>
                            </tr>
                        </>)
                        }

                        <tr>
                            <td colSpan={3} className="comp_section-title">DESIGN 2</td>
                        </tr>
                        <tr>
                            <td className="comp_label">ID</td>
                            <td>{leftExperiment?.design2?.id}</td>
                            <td>{rightExperiment?.design2?.id}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Design Title</td>
                            <td>{leftExperiment?.design2?.title}</td>
                            <td>{rightExperiment?.design2?.title}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Surface (min|max)</td>
                            <td>{leftExperiment?.design2?.surface.type} ({leftExperiment?.design2?.surface.thickness.min} | {leftExperiment?.design2?.surface.thickness.max})</td>
                            <td>{rightExperiment?.design2?.surface.type} ({rightExperiment?.design2?.surface.thickness.min} | {rightExperiment?.design2?.surface.thickness.max})</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Base (min|max)</td>
                            <td>{leftExperiment?.design2?.base.type} ({leftExperiment?.design2?.base.thickness.min} | {leftExperiment?.design2?.base.thickness.max})</td>
                            <td>{rightExperiment?.design2?.base.type} ({rightExperiment?.design2?.base.thickness.min} | {rightExperiment?.design2?.base.thickness.max})</td>
                        </tr>

                        <tr>
                            <td className="comp_label">k value</td>
                            <td>{leftExperiment?.design2?.kValue.min}</td>
                            <td>{rightExperiment?.design2?.kValue.max}</td>
                        </tr>

                        {leftExperiment?.design2?.surface.type === "JPCP" && ( 
                        <>
                            <tr>
                                <td className="comp_label">PCC Elastic Modulus</td>
                                <td>{leftExperiment?.design2?.jpcpDesign?.pccElasticModulus.min} | {leftExperiment?.design2?.jpcpDesign?.pccElasticModulus.max} | {leftExperiment?.design2?.jpcpDesign?.pccElasticModulus.mean} | {leftExperiment?.design2?.jpcpDesign?.pccElasticModulus.distribution}</td>
                                <td>{rightExperiment?.design2?.jpcpDesign?.pccElasticModulus.min} | {rightExperiment?.design2?.jpcpDesign?.pccElasticModulus.max} | {rightExperiment?.design2?.jpcpDesign?.pccElasticModulus.mean} | {rightExperiment?.design2?.jpcpDesign?.pccElasticModulus.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">PCC Comp Strength</td>
                                <td>{leftExperiment?.design2?.jpcpDesign?.pccCompStrength.min} | {leftExperiment?.design2?.jpcpDesign?.pccCompStrength.max} | {leftExperiment?.design2?.jpcpDesign?.pccCompStrength.mean} | {leftExperiment?.design2?.jpcpDesign?.pccCompStrength.distribution}</td>
                                <td>{rightExperiment?.design2?.jpcpDesign?.pccCompStrength.min} | {rightExperiment?.design2?.jpcpDesign?.pccCompStrength.max} | {rightExperiment?.design2?.jpcpDesign?.pccCompStrength.mean} | {rightExperiment?.design2?.jpcpDesign?.pccCompStrength.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">PCC Modules Of Rupture</td>
                                <td>{leftExperiment?.design2?.jpcpDesign?.pccModulesOfRupture.min} | {leftExperiment?.design2?.jpcpDesign?.pccModulesOfRupture.max} | {leftExperiment?.design2?.jpcpDesign?.pccModulesOfRupture.mean} | {leftExperiment?.design2?.jpcpDesign?.pccModulesOfRupture.distribution}</td>
                                <td>{rightExperiment?.design2?.jpcpDesign?.pccModulesOfRupture.min} | {rightExperiment?.design2?.jpcpDesign?.pccModulesOfRupture.max} | {rightExperiment?.design2?.jpcpDesign?.pccModulesOfRupture.mean} | {rightExperiment?.design2?.jpcpDesign?.pccModulesOfRupture.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Coefficient Of Thermal Expansion</td>
                                <td>{leftExperiment?.design2?.jpcpDesign?.coefficientOfThermalExpansion.min} | {leftExperiment?.design2?.jpcpDesign?.coefficientOfThermalExpansion.max} | {leftExperiment?.design2?.jpcpDesign?.coefficientOfThermalExpansion.mean} | {leftExperiment?.design2?.jpcpDesign?.coefficientOfThermalExpansion.distribution}</td>
                                <td>{rightExperiment?.design2?.jpcpDesign?.coefficientOfThermalExpansion.min} | {rightExperiment?.design2?.jpcpDesign?.coefficientOfThermalExpansion.max} | {rightExperiment?.design2?.jpcpDesign?.coefficientOfThermalExpansion.mean} | {rightExperiment?.design2?.jpcpDesign?.coefficientOfThermalExpansion.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Joint Spacing</td>
                                <td>{leftExperiment?.design2?.jpcpDesign?.jointSpacing.min} | {leftExperiment?.design2?.jpcpDesign?.jointSpacing.max} | {leftExperiment?.design2?.jpcpDesign?.jointSpacing.mean} | {leftExperiment?.design2?.jpcpDesign?.jointSpacing.distribution}</td>
                                <td>{rightExperiment?.design2?.jpcpDesign?.jointSpacing.min} | {rightExperiment?.design2?.jpcpDesign?.jointSpacing.max} | {rightExperiment?.design2?.jpcpDesign?.jointSpacing.mean} | {rightExperiment?.design2?.jpcpDesign?.jointSpacing.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Base Resilient Modulus</td>
                                <td>{leftExperiment?.design2?.jpcpDesign?.baseResilientModulus.min} | {leftExperiment?.design2?.jpcpDesign?.baseResilientModulus.max} | {leftExperiment?.design2?.jpcpDesign?.baseResilientModulus.mean} | {leftExperiment?.design2?.jpcpDesign?.baseResilientModulus.distribution}</td>
                                <td>{rightExperiment?.design2?.jpcpDesign?.baseResilientModulus.min} | {rightExperiment?.design2?.jpcpDesign?.baseResilientModulus.max} | {rightExperiment?.design2?.jpcpDesign?.baseResilientModulus.mean} | {rightExperiment?.design2?.jpcpDesign?.baseResilientModulus.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Subgrade Resilient Modulus</td>
                                <td>{leftExperiment?.design2?.jpcpDesign?.subgradeResilientModulus.min} | {leftExperiment?.design2?.jpcpDesign?.subgradeResilientModulus.max} | {leftExperiment?.design2?.jpcpDesign?.subgradeResilientModulus.mean} | {leftExperiment?.design2?.jpcpDesign?.subgradeResilientModulus.distribution}</td>
                                <td>{rightExperiment?.design2?.jpcpDesign?.subgradeResilientModulus.min} | {rightExperiment?.design2?.jpcpDesign?.subgradeResilientModulus.max} | {rightExperiment?.design2?.jpcpDesign?.subgradeResilientModulus.mean} | {rightExperiment?.design2?.jpcpDesign?.subgradeResilientModulus.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Depth To Rigid Found</td>
                                <td>{leftExperiment?.design2?.jpcpDesign?.depthToRigidFound.min} | {leftExperiment?.design2?.jpcpDesign?.depthToRigidFound.max} | {leftExperiment?.design2?.jpcpDesign?.depthToRigidFound.mean} | {leftExperiment?.design2?.jpcpDesign?.depthToRigidFound.distribution}</td>
                                <td>{rightExperiment?.design2?.jpcpDesign?.depthToRigidFound.min} | {rightExperiment?.design2?.jpcpDesign?.depthToRigidFound.max} | {rightExperiment?.design2?.jpcpDesign?.depthToRigidFound.mean} | {rightExperiment?.design2?.jpcpDesign?.depthToRigidFound.distribution}</td>
                            </tr>
                        </>)}

                        {leftExperiment?.design2?.surface.type === "HMA" && ( 
                        <>
                            <tr>
                                <td className="comp_label">AC Binder Type</td>
                                <td>{leftExperiment?.design2?.hmaDesign?.acBinderType.value}</td>
                                <td>{rightExperiment?.design2?.hmaDesign?.acBinderType.value}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Effective Binder Content</td>
                                <td>{leftExperiment?.design2?.hmaDesign?.effectiveBinderContent.min} | {leftExperiment?.design2?.hmaDesign?.effectiveBinderContent.max} | {leftExperiment?.design2?.hmaDesign?.effectiveBinderContent.mean} | {leftExperiment?.design2?.hmaDesign?.effectiveBinderContent.distribution}</td>
                                <td>{rightExperiment?.design2?.hmaDesign?.effectiveBinderContent.min} | {rightExperiment?.design2?.hmaDesign?.effectiveBinderContent.max} | {rightExperiment?.design2?.hmaDesign?.effectiveBinderContent.mean} | {rightExperiment?.design2?.hmaDesign?.effectiveBinderContent.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Air Voids</td>
                                <td>{leftExperiment?.design2?.hmaDesign?.airVoids.min} | {leftExperiment?.design2?.hmaDesign?.airVoids.max} | {leftExperiment?.design2?.hmaDesign?.airVoids.mean} | {leftExperiment?.design2?.hmaDesign?.airVoids.distribution}</td>
                                <td>{rightExperiment?.design2?.hmaDesign?.airVoids.min} | {rightExperiment?.design2?.hmaDesign?.airVoids.max} | {rightExperiment?.design2?.hmaDesign?.airVoids.mean} | {rightExperiment?.design2?.hmaDesign?.airVoids.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Base Resilient Modulus</td>
                                <td>{leftExperiment?.design2?.hmaDesign?.baseResilientModulus.min} | {leftExperiment?.design2?.hmaDesign?.baseResilientModulus.max} | {leftExperiment?.design2?.hmaDesign?.baseResilientModulus.mean} | {leftExperiment?.design2?.hmaDesign?.baseResilientModulus.distribution}</td>
                                <td>{rightExperiment?.design2?.hmaDesign?.baseResilientModulus.min} | {rightExperiment?.design2?.hmaDesign?.baseResilientModulus.max} | {rightExperiment?.design2?.hmaDesign?.baseResilientModulus.mean} | {rightExperiment?.design2?.hmaDesign?.baseResilientModulus.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Subgrade Resilient Modulus</td>
                                <td>{leftExperiment?.design2?.hmaDesign?.subgradeResilientModulus.min} | {leftExperiment?.design2?.hmaDesign?.subgradeResilientModulus.max} | {leftExperiment?.design2?.hmaDesign?.subgradeResilientModulus.mean} | {leftExperiment?.design2?.hmaDesign?.subgradeResilientModulus.distribution}</td>
                                <td>{rightExperiment?.design2?.hmaDesign?.subgradeResilientModulus.min} | {rightExperiment?.design2?.hmaDesign?.subgradeResilientModulus.max} | {rightExperiment?.design2?.hmaDesign?.subgradeResilientModulus.mean} | {rightExperiment?.design2?.hmaDesign?.subgradeResilientModulus.distribution}</td>
                            </tr>

                            <tr>
                                <td className="comp_label">Depth To Rigid Foundation</td>
                                <td>{leftExperiment?.design2?.hmaDesign?.depthToRigidFoundation.min} | {leftExperiment?.design2?.hmaDesign?.depthToRigidFoundation.max} | {leftExperiment?.design2?.hmaDesign?.depthToRigidFoundation.mean} | {leftExperiment?.design2?.hmaDesign?.depthToRigidFoundation.distribution}</td>
                                <td>{rightExperiment?.design2?.hmaDesign?.depthToRigidFoundation.min} | {rightExperiment?.design2?.hmaDesign?.depthToRigidFoundation.max} | {rightExperiment?.design2?.hmaDesign?.depthToRigidFoundation.mean} | {rightExperiment?.design2?.hmaDesign?.depthToRigidFoundation.distribution}</td>
                            </tr>
                        </>)
                        }

                        <tr>
                            <td colSpan={3} className="comp_section-title">CONCRETE EMBODIED EMISSION</td>
                        </tr>
                        <tr>
                            <td className="comp_label">ID</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.id}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.id}</td>
                        </tr>

                        <tr>
                            <td className="comp_label"></td>
                            <td colSpan={2} className="comp_section-subtitle">Materials</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Portland Cement</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.material.portlandCement}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.material.portlandCement}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Fly Ash</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.material.flyAsh}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.material.flyAsh}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Crushed Coarse Aggregate</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.material.crushedCoarseAggregate}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.material.crushedCoarseAggregate}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Natural Coarse Aggregate</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.material.naturalCoarseAggregate}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.material.naturalCoarseAggregate}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Crushed Fine Aggregate</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.material.crushedFineAggregate}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.material.crushedFineAggregate}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Natural Fine Aggregate</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.material.naturalFineAggregate}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.material.naturalFineAggregate}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Air</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.material.air}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.material.air}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Air Entraining Mixture</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.material.airEntrainingMixture}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.material.airEntrainingMixture}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Water Reducer</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.material.waterReducer}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.material.waterReducer}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">High Range Water Reducer</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.material.highRangeWaterReducer}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.material.highRangeWaterReducer}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Accelerator</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.material.accelerator}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.material.accelerator}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Material Total</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.material.total}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.material.total}</td>
                        </tr>

                        <tr>
                            <td className="comp_label"></td>
                            <td colSpan={2} className="comp_section-subtitle">Energy</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Purchased Electricity</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.energy.purchasedElectricity}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.energy.purchasedElectricity}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Natural Gas</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.energy.naturalGas}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.energy.naturalGas}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Secondary Fuels - Liquid</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.energy.secondaryFuelLiquid}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.energy.secondaryFuelLiquid}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Secondary Fuels - Solid</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.energy.secondaryFuelSolid}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.energy.secondaryFuelSolid}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Fuel Oil</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.energy.fuelOil}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.energy.fuelOil}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Diesel</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.energy.diesel}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.energy.diesel}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Gasoline</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.energy.gasoline}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.energy.gasoline}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">LPG</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.energy.lpg}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.energy.lpg}</td>
                        </tr>

                        <tr>
                            <td className="comp_label"></td>
                            <td colSpan={2} className="comp_section-subtitle">Transportation</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Transportation</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.transportation.transportation}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.transportation.transportation}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Transportation Total</td>
                            <td>{leftExperiment?.concreteEmbodiedEmission?.transportation.total}</td>
                            <td>{rightExperiment?.concreteEmbodiedEmission?.transportation.total}</td>
                        </tr>

                        <tr>
                            <td colSpan={3} className="comp_section-title">ASPHALT EMBODIED EMISSION</td>
                        </tr>
                        <tr>
                            <td className="comp_label"></td>
                            <td colSpan={2} className="comp_section-subtitle">Materials</td>
                        </tr>
                        <tr>
                            <td className="comp_label">Bitumen content</td>
                            <td>{leftExperiment?.asphaltEmbodiedEmission?.material.bitumenContent}</td>
                            <td>{rightExperiment?.asphaltEmbodiedEmission?.material.bitumenContent}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Bitumen impact</td>
                            <td>{leftExperiment?.asphaltEmbodiedEmission?.material.bitumenImpact}</td>
                            <td>{rightExperiment?.asphaltEmbodiedEmission?.material.bitumenImpact}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Gravel impact</td>
                            <td>{leftExperiment?.asphaltEmbodiedEmission?.material.gravelImpact}</td>
                            <td>{rightExperiment?.asphaltEmbodiedEmission?.material.gravelImpact}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Sand impact</td>
                            <td>{leftExperiment?.asphaltEmbodiedEmission?.material.sandImpact}</td>
                            <td>{rightExperiment?.asphaltEmbodiedEmission?.material.sandImpact}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">RAP Content</td>
                            <td>{leftExperiment?.asphaltEmbodiedEmission?.material.rapContent}</td>
                            <td>{rightExperiment?.asphaltEmbodiedEmission?.material.rapContent}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">WAP Content</td>
                            <td>{leftExperiment?.asphaltEmbodiedEmission?.material.wapContent}</td>
                            <td>{rightExperiment?.asphaltEmbodiedEmission?.material.wapContent}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Material Total</td>
                            <td>{leftExperiment?.asphaltEmbodiedEmission?.material.total}</td>
                            <td>{rightExperiment?.asphaltEmbodiedEmission?.material.total}</td>
                        </tr>

                        <tr>
                            <td className="comp_label"></td>
                            <td colSpan={2} className="comp_section-subtitle">Energy</td>
                        </tr>
                        <tr>
                            <td className="comp_label">Asphalt heating impact</td>
                            <td>{leftExperiment?.asphaltEmbodiedEmission?.energy.asphaltHeatingImpact}</td>
                            <td>{rightExperiment?.asphaltEmbodiedEmission?.energy.asphaltHeatingImpact}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Energy Total</td>
                            <td>{leftExperiment?.asphaltEmbodiedEmission?.energy.total}</td>
                            <td>{rightExperiment?.asphaltEmbodiedEmission?.energy.total}</td>
                        </tr>

                        <tr>
                            <td className="comp_label"></td>
                            <td colSpan={2} className="comp_section-subtitle">Transportation</td>
                        </tr>
                        <tr>
                            <td className="comp_label">Transportation GHG</td>
                            <td>{leftExperiment?.asphaltEmbodiedEmission?.transportation.transportationGHG}</td>
                            <td>{rightExperiment?.asphaltEmbodiedEmission?.transportation.transportationGHG}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Transportation Total</td>
                            <td>{leftExperiment?.asphaltEmbodiedEmission?.transportation.total}</td>
                            <td>{rightExperiment?.asphaltEmbodiedEmission?.transportation.total}</td>
                        </tr>

                        <tr>
                            <td className="comp_label">Total</td>
                            <td>{leftExperiment?.asphaltEmbodiedEmission?.total}</td>
                            <td>{rightExperiment?.asphaltEmbodiedEmission?.total}</td>
                        </tr>

                    </table>
                </div>
            </div>
        </div>
    );
}

export default ComparisonPage;